import { Button } from "@/shared/ui/button.tsx"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/ui/dialog.tsx"
import { format } from "date-fns"
import { CalendarIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import { Calendar } from "@/shared/ui/calendar.tsx"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/ui/popover.tsx"
import { useState } from "react"
import { SocialPostType } from "../types"
import { useUpdatePostBody } from "../api"

type Props = {
  trigger: JSX.Element,
  data: SocialPostType,
}

const DateCheckDialog = ({ data, trigger }: Props) => {

  const [date, setDate] = useState<Date>()

  const { updatePostBody, isPending } = useUpdatePostBody()

  // const { schedulePost } = useSchedulePost(onSchedule)

  const saveInputAndScheduleHandler = () => {
    updatePostBody({
      post_date: format(date!, 'yyyy-MM-dd'),
      post_time: data.post_time,
      post_id: data.post_id,
      hashtags: data.tags,
      post_content: data.post_content
    })
  }



  return (
    <Dialog>
      <DialogTrigger asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Date Mismatch</DialogTitle>
          <DialogDescription>
            There seems to be a date mismatch, change the date and proceed
          </DialogDescription>
        </DialogHeader>
        <Popover modal>
          <PopoverTrigger asChild>
            <Button
              variant={"outline"}
              className={cn(
                "w-full justify-start text-left font-normal",
                !date && "text-muted-foreground"
              )}
            >
              <CalendarIcon />
              {date ? format(date, "PPP") : <span>Pick a date</span>}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar
              mode="single"
              selected={date}
              onSelect={setDate}
              initialFocus
            />
          </PopoverContent>
        </Popover>
        <DialogFooter>
          <DialogClose>
            <Button type="button"
              disabled={date === undefined || isPending}
              onClick={saveInputAndScheduleHandler}
            >
              Save changes</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default DateCheckDialog;
